import restDirectory from './mesh/rest-directory/routes.ts';
import { meshRelays } from './mesh/ws/relays/core.ts';
import { meshCluster } from './mesh/ws/cluster/core.ts';
import type {ServerConfigurer, ServerWebSocketOptions} from '@interopio/gateway-server/web/server';
import type { Relays, NodeConnections } from './mesh/types.ts';
import { GatewayServer } from '@interopio/gateway-server';
import type { Logger } from '@interopio/gateway/logging/api';

function connectNodeRelays(logger: Logger, relays: Relays, connections: NodeConnections) {
    relays.on('disconnect', (key, node, links) => {
        for (const [linkNode, linkKey] of links) {
            try {
                relays.send(linkKey, linkNode, { type: 'bye', from: node, to: linkNode }, (k, err?) => {
                    if (err) {
                        logger.warn(`${k} error writing 'bye' msg to ${linkNode}: ${err}`);
                        return;
                    }
                    if (logger.enabledFor('debug')) {
                        logger.debug(`${k} sent 'bye' msg to ${linkNode}`);
                    }
                });
            } catch (err) {
                logger.warn(`${linkKey} exception writing 'bye' msg to ${linkNode}: ${err}`);
            }
        }
    });

}

export const mesh = async (
    options: {
        logger: Logger,
        enabled?: boolean,
        relays: Relays,
        connections: NodeConnections,
        socket: ServerWebSocketOptions
    },
    configurer: ServerConfigurer,
    config: GatewayServer.ServerConfig
) => {
    const {enabled, logger, relays, connections} = options;
    if (enabled !== true) {
        if (logger.enabledFor('debug')) {
            logger.debug(`no mesh`);
        }
        return;
    }
    let {socket} = options;
    const authorize = socket.authorize ?? {access: config.auth.type === 'none' ? 'permitted' : 'authenticated'};
    socket = {ping: 30000, authorize: authorize, ...socket};
    connectNodeRelays(logger, relays, connections);
    restDirectory({connections, authorize}, configurer);
    configurer.socket(
        {
            path: '/cluster', options: socket,
            factory: meshCluster({logger, relays})
        },
        {
            path: '/relays', options: socket,
            factory: meshRelays({logger, relays})
        }
    );
}

import BridgeMeshChannel from './mesh/gateway/mesh.ts';
export { BridgeMeshChannel };
